import Vue from 'vue'
import VueRouter from 'vue-router'
import Faqs from '../views/Faqs.vue'
import FaqsPublic from '../views/FaqsPublic.vue'
import Home from '../views/Home.vue'
import Login from '../views/Login.vue'
import Logout from '../views/Logout.vue'
import Fichar from '../views/Fichar.vue'
import FicharIncidencia from '../views/FicharIncidencia.vue'
import ConsultarFichajes from '../views/ConsultarFichajes.vue'
import CambiarClave from '../views/CambiarClave.vue'

import ErrorConexionApi from '../views/ErrorConexionApi.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/', name: 'home', component: Home
  },
  {
    path: '/logout', name: 'logout', component: Logout
  },
  {
    path: '/faqs', name: 'faqs', component: Faqs
  },
  {
    path: '/faqs-public', name: 'faqsPublic', component: FaqsPublic, meta: { layout: 'publicLayout'}
  },
  {
    path: '/cambiar-clave', name: 'CambiarClave', component: CambiarClave, meta: { layout: 'publicLayout'}
  },
  {
    path: '/fichar', name: 'Fichar', component: Fichar,
  },
  {
    path: '/fichar-incidencia', name: 'FicharIncidencia', component: FicharIncidencia,
  },
  {
    path: '/consultar-fichajes', name: 'ConsultarFichajes', component: ConsultarFichajes,
  },
  {
    path: '/error-conexion', name: 'ErrorConexionApi', component: ErrorConexionApi, meta: { layout: 'publicLayout'}
  },
  
  {
    path: '/about', name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  { path: '/login', component: Login, name: 'login', meta: { layout: 'publicLayout'}}
]

const router = new VueRouter({
  base: process.env.BASE_URL,
  routes,
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

export default router
